import { Button, Form } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Icon from "../../components/Icon/Icon";
import AppHeader from "../../components/layout/AppHeader";
import SignupRequestForm from "../../components/_shared/SignupRequestForm";
import { getSignupCategory } from "../../redux/actions/accountActions";
import { sendSingupRequest } from "../../redux/actions/userActions";
import { RootState } from "../../redux/rootReducer";
import ROUTES from "../../routes";
import validateMessages from "../../utils/validate";

function Signup() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [signupForm] = Form.useForm();
  const [requestSend, setRequestSend] = useState(false);
  const { signupReqPending, signupReqFulfilled } = useSelector(
    (state: RootState) => state.user,
  );

  useEffect(() => {
    dispatch(getSignupCategory());
  }, []);

  const onSignupRequest = async () => {
    try {
      await signupForm.validateFields();
    } catch (errorInfo) {
      return;
    }

    const formFields = signupForm.getFieldsValue();
    formFields.category = [formFields.category];
    // console.log("Validation passed. fields: ", formFields);
    dispatch(sendSingupRequest(formFields));
  };

  useEffect(() => {
    /* sendRequest success */
    if (signupReqFulfilled) {
      setRequestSend(true);
    }
  }, [signupReqPending]);

  const onLogin = () => navigate(ROUTES.PATHS.LOGIN);

  return (
    <div className="default-text min-h-screen">
      <AppHeader>
        <div
          className="text-white cursor-pointer"
          onClick={onLogin}
          aria-hidden="true"
        >
          Sign In
        </div>
      </AppHeader>
      <div className="grid justify-center pb-12">
        <div className="mt-[72px] md:mt-[90px] mb-3 md:mb-9 text-heading21 md:text-heading24 text-center">
          Account Signup Request
        </div>
        <div className="sm:default-border w-auto md:w-[740px]">
          <div className="py-4 px-3 md:px-6 resetborder-b border-light-silver">
            <span className="text-base font-bold">Signup Request</span>
          </div>
          {requestSend || (
            <div className="my-6 px-3 md:px-6">
              <Form
                form={signupForm}
                layout="vertical"
                name="signupForm"
                validateMessages={validateMessages}
              >
                <SignupRequestForm />
              </Form>
            </div>
          )}
          {requestSend && (
            <div className="my-[87px] px-6 text-center text-base">
              <Icon icon="check_circle" className="h-20 w-20 text-success" />
              <div className="font-bold">Signup Request sent successfully</div>
              <div className="text-dark-silver mt-2.5">
                Thank you for your interest in CLAP application. Your
                information will be verified and you will be contacted by the
                CLAP team to proceed with the next steps to complete the signup.
              </div>
            </div>
          )}
          <div className="py-2.5 px-4 resetborder-t border-light-silver flex justify-end gap-2">
            <Button onClick={onLogin}>
              {requestSend ? "Close" : "Cancel"}
            </Button>
            {requestSend || (
              <Button
                type="primary"
                onClick={onSignupRequest}
                loading={signupReqPending as boolean}
              >
                Send Request
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Signup;
